import { Slice as FinancialSlice } from "./redux/Slice";
export { FinancialYear } from "./FinancialYear.logic";

export { FinancialSlice };
